if (!customElements.get('td-accordion')) {
  class TdAccordion extends HTMLElement {
  
    constructor() {
      super();
      this.ACCORDION_TRIGGERS = this.querySelectorAll('[data-accordion-trigger]');
      this.ACCORDION_CONTENT = this.querySelector('[data-accordion-content]');
      this.ACTIVE_CLASS = 'td-active';
      this.isExpanded = this.classList.contains(this.ACTIVE_CLASS);
    }
  
    connectedCallback() {
      if (!this.ACCORDION_CONTENT) {
        return;
      }
      this.setAccordionHeight();
      this.attachListeners();
    }

    setAccordionHeight() {
      this.isExpanded = this.classList.contains(this.ACTIVE_CLASS);
      if (this.isExpanded) {
        this.ACCORDION_CONTENT.style.maxHeight = this.ACCORDION_CONTENT.scrollHeight + 'px';
      } else {
        this.ACCORDION_CONTENT.style.maxHeight = '0px';
      }
    }
  
    attachListeners() {
      this.ACCORDION_TRIGGERS.forEach((trigger) => {
        trigger.addEventListener('click', this.toggleAccordion.bind(this));
      });
      window.addEventListener('resize', this.setAccordionHeight.bind(this));
      document.addEventListener('pdp:dimensions-updated', this.setAccordionHeight.bind(this));
    }

    toggleAccordion() {
      this.isExpanded = this.classList.contains(this.ACTIVE_CLASS);
  
      if (this.isExpanded) {
        this.ACCORDION_CONTENT.style.maxHeight = '0px';
        this.classList.remove(this.ACTIVE_CLASS);
      } else {
        this.ACCORDION_CONTENT.style.maxHeight = this.ACCORDION_CONTENT.scrollHeight + 'px';
        this.classList.add(this.ACTIVE_CLASS);
      }
    }
    
  }
  customElements.define('td-accordion', TdAccordion);
}